import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MessageCenterIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 14 14" {...props}>
            <path
                fill="none"
                stroke="#303030"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.66667 4.66667H7M3.66667 7H9M3.66667 11V12.557C3.66667 12.9122 3.66667 13.0898 3.73949 13.1811C3.80282 13.2604 3.89885 13.3066 4.00036 13.3065C4.11708 13.3063 4.25578 13.1954 4.53317 12.9735L6.12348 11.7012C6.44834 11.4413 6.61078 11.3114 6.79166 11.219C6.95213 11.137 7.12295 11.0771 7.29948 11.0408C7.49845 11 7.70646 11 8.1225 11H9.8C10.9201 11 11.4802 11 11.908 10.782C12.2843 10.5903 12.5903 10.2843 12.782 9.90798C13 9.48016 13 8.9201 13 7.8V4.2C13 3.07989 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.07989 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V8.33333C1 8.95331 1 9.2633 1.06815 9.51764C1.25308 10.2078 1.79218 10.7469 2.48236 10.9319C2.73669 11 3.04669 11 3.66667 11Z"
            />
        </SvgIcon>
    );
};

export default MessageCenterIcon;
